// src/utils/mockWeatherData.ts

export interface WeatherDataPoint {
  time: string;
  aht_temp: number | null;
  aht_hum: number | null;
  bmp_temp: number | null;
  bmp_pres: number | null;
  ds18_temp: number | null;
  wind_speed: number | null;
  wind_gust: number | null;
  rain_mm: number | null;
  wind_dir_val: number | null;
  soil_moisture: number | null;
}

const API_URL = "/weather-proxy.php"; // produkcja: PHP proxy (ukryty klucz)

// helpery
const toNum = (v: any) =>
  v === null || v === undefined || v === "" || Number.isNaN(Number(v))
    ? null
    : Number(v);

function normalize(x: any): WeatherDataPoint {
  return {
    time: x.time ?? x._time ?? new Date().toISOString(),
    aht_temp: toNum(x.aht_temp),
    aht_hum: toNum(x.aht_hum),
    bmp_temp: toNum(x.bmp_temp),
    bmp_pres: toNum(x.bmp_pres),
    ds18_temp: toNum(x.ds18_temp),
    wind_speed: toNum(x.wind_speed),
    wind_gust: toNum(x.wind_gust),
    rain_mm: toNum(x.rain_mm),
    wind_dir_val: toNum(x.wind_dir_val),
    soil_moisture: toNum(x.soil_moisture),
  };
}

/**
 * Pobiera dane i przycina do ostatnich `rangeHours` godzin (domyślnie 24).
 * Zwraca zawsze tablicę posortowaną rosnąco po czasie.
 */
export async function generateMockData(
  rangeHours: number = 24
): Promise<WeatherDataPoint[]> {
  try {
    const res = await fetch(API_URL, { cache: "no-store" });
    const raw = await res.json();

    // dopasuj kształt odpowiedzi
    let arr: any[] = [];
    if (Array.isArray(raw)) arr = raw;
    else if (raw && typeof raw === "object") arr = [raw];
    else arr = [];

    // normalizacja i sortowanie
    const norm = arr.map(normalize).sort(
      (a, b) => new Date(a.time).getTime() - new Date(b.time).getTime()
    );

    // filtrowanie po zakresie godzin
    const cutoff = Date.now() - rangeHours * 60 * 60 * 1000;
    return norm.filter((d) => new Date(d.time).getTime() >= cutoff);
  } catch (e) {
    console.error("Błąd pobierania danych pogodowych:", e);
    return [];
  }
}

/** Zwraca ostatni pomiar (albo null, gdy brak) */
export async function getCurrentWeather(): Promise<WeatherDataPoint | null> {
  // bierzemy szersze okno, by na pewno mieć ostatni punkt
  const data = await generateMockData(72);
  return data.length ? data[data.length - 1] : null;
}

// Możesz zostawić atrapę lub zbudować prognozę na podstawie ostatnich danych
export function generateHourlyForecast() {
  return [];
}
